import api from '@/services/api';

/**
 * Busca um customer pelo CPF/CNPJ.
 * @param {string} cpfCnpj - CPF ou CNPJ sem formatação
 * @returns {{ found: boolean, name?: string, email?: string, phone?: string }}
 */
export async function lookupGuest(cpfCnpj) {
  const { data } = await api.get('/guests/lookup', {
    params: { cpf_cnpj: cpfCnpj },
  });
  return data;
}

/**
 * Cria/atualiza um customer no provedor de pagamentos e salva no banco.
 * @param {{
 *   name: string,
 *   cpf_cnpj: string,
 *   email: string,
 *   phone?: string,
 *   postal_code?: string,
 *   address_number?: string,
 *   address?: string,
 *   province?: string,
 *   city?: string,
 * }} payload
 * @returns {{ id: string, provider_customer_id: string }}
 */
export async function createGuest(payload) {
  const { data } = await api.post('/guests', {
    name: payload.name,
    cpf_cnpj: payload.cpf_cnpj,
    email: payload.email,
    phone: payload.phone,
    postal_code: payload.postal_code,
    address_number: payload.address_number,
    address: payload.address,
    province: payload.province,
    city: payload.city || '',
  });
  return data;
}
